module.exports = __webpack_public_path__ + "static/img/3-1.aaef83ff.png";